import TimeDisplay from '@/components/TimeDisplay.vue';
import AchievementInfo from './AchievementInfo.vue';
export default {
    components: { TimeDisplay, AchievementInfo },
    props: {
        achievement: { type: Object, required: true },
        noModal: { type: Boolean, default: false },
        group: { type: Array, default: () => [] },
    },
    computed: {
        iconClass() {
            return this.achievement.icon || 'fas fa-tag';
        },
        awardedGroup() {
            if (!this.group.length) {
                return 'validUntil' in this.achievement ? [this.achievement] : [];
            }
            return this.group.filter((achievement) => 'validUntil' in achievement);
        },
    },
    methods: {
        onClick() {
            if (this.noModal) {
                this.$emit('click');
            }
            else {
                // @ts-expect-error: $refs.detailsModal is a b-modal component
                this.$refs.detailsModal.show();
            }
        },
    },
};
